module.exports = {
	"contractName": "FakeFibonacciLib",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "calculatedFibNumber",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "start",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_start",
					"type": "uint256"
				}
			],
			"name": "setStart",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "n",
					"type": "uint256"
				}
			],
			"name": "setFibonacci",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "0x608060405234801561001057600080fd5b5061017d806100206000396000f3006080604052600436106100615763ffffffff7c0100000000000000000000000000000000000000000000000000000000600035041663bbe1d75b8114610066578063be9a65551461008d578063f6a03ebf146100a2578063fe75faab146100bc575b600080fd5b34801561007257600080fd5b5061007b6100d4565b60408051918252519081900360200190f35b34801561009957600080fd5b5061007b6100da565b3480156100ae57600080fd5b506100ba6004356100e0565b005b3480156100c857600080fd5b506100ba6004356100e5565b60015481565b60005481565b600055565b6100ee816100f4565b60015550565b6000811515610106575060005461014c565b816001141561011b575060005460010161014c565b8160021415610130575060005460020161014c565b61013c600383036100f4565b610148600184036100f4565b0190505b9190505600a165627a7a72305820864baad3654c31c8c20ffef2c7f53c23c68e3d5ff831b204fbd9ab5b834421270029",
	"deployedBytecode": "0x6080604052600436106100615763ffffffff7c0100000000000000000000000000000000000000000000000000000000600035041663bbe1d75b8114610066578063be9a65551461008d578063f6a03ebf146100a2578063fe75faab146100bc575b600080fd5b34801561007257600080fd5b5061007b6100d4565b60408051918252519081900360200190f35b34801561009957600080fd5b5061007b6100da565b3480156100ae57600080fd5b506100ba6004356100e0565b005b3480156100c857600080fd5b506100ba6004356100e5565b60015481565b60005481565b600055565b6100ee816100f4565b60015550565b6000811515610106575060005461014c565b816001141561011b575060005460010161014c565b8160021415610130575060005460020161014c565b61013c600383036100f4565b610148600184036100f4565b0190505b9190505600a165627a7a72305820864baad3654c31c8c20ffef2c7f53c23c68e3d5ff831b204fbd9ab5b834421270029",
	"sourceMap": "26:491:9:-;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;26:491:9;;;;;;;",
	"deployedSourceMap": "26:491:9:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;80:34;;8:9:-1;5:2;;;30:1;27;20:12;5:2;80:34:9;;;;;;;;;;;;;;;;;;;;56:20;;8:9:-1;5:2;;;30:1;27;20:12;5:2;56:20:9;;;;119:66;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;119:66:9;;;;;;;189:85;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;189:85:9;;;;;80:34;;;;:::o;56:20::-;;;;:::o;119:66::-;166:5;:14;119:66::o;189:85::-;257:12;267:1;257:9;:12::i;:::-;235:19;:34;-1:-1:-1;189:85:9:o;278:237::-;326:7;345:6;;341:170;;;-1:-1:-1;360:5:9;;353:12;;341:170;380:1;385;380:6;376:135;;;-1:-1:-1;395:5:9;;403:1;395:9;388:16;;376:135;419:1;424;419:6;415:96;;;-1:-1:-1;434:5:9;;442:1;434:9;427:16;;415:96;488:16;502:1;498;:5;488:9;:16::i;:::-;469;483:1;479;:5;469:9;:16::i;:::-;:35;462:42;;415:96;278:237;;;:::o",
	"source": "pragma solidity ^0.4.24;\n\ncontract FakeFibonacciLib {\n  uint256 public start;\n  uint256 public calculatedFibNumber;\n\n  function setStart(uint256 _start) public {\n    start = _start;\n  }\n\n  function setFibonacci(uint256 n) public {\n    calculatedFibNumber = fibonacci(n);\n  }\n\n  function fibonacci(uint256 n) internal returns (uint256) {\n    if (n == 0) return start;\n    else if (n == 1) return start + 1;\n    else if (n == 2) return start + 2;\n    else {\n      return fibonacci(n - 1) + fibonacci(n - 3);\n    }\n  }\n}\n\ncontract FakeFibonacciBank {\n  address public fakeFibonacciLibrary;\n  uint256 public calculatedFibNumber;\n  uint256 public start = 3;\n  uint256 public withdrawalCounter;\n  bytes4 constant FIBSIG = bytes4(sha3(\"setFibonacci(uint256)\"));\n\n  constructor(address _fakeFibonacciLibrary) public payable {\n    fakeFibonacciLibrary = _fakeFibonacciLibrary;\n  }\n\n  function withdraw() {\n    withdrawalCounter += 1;\n    // calculate the fibonacci number for the current withdrawal user\n    require(fakeFibonacciLibrary.delegatecall(FIBSIG, withdrawalCounter));\n    msg.sender.transfer(calculatedFibNumber * 0.001 ether);\n  }\n\n  function() public {\n    require(fakeFibonacciLibrary.delegatecall(msg.data));\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/FakeFibonacciBank.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/FakeFibonacciBank.sol",
		"exportedSymbols": {
			"FakeFibonacciBank": [
				1172
			],
			"FakeFibonacciLib": [
				1107
			]
		},
		"id": 1173,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1037,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:9"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1107,
				"linearizedBaseContracts": [
					1107
				],
				"name": "FakeFibonacciLib",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 1039,
						"name": "start",
						"nodeType": "VariableDeclaration",
						"scope": 1107,
						"src": "56:20:9",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 1038,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "56:7:9",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1041,
						"name": "calculatedFibNumber",
						"nodeType": "VariableDeclaration",
						"scope": 1107,
						"src": "80:34:9",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 1040,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "80:7:9",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1050,
							"nodeType": "Block",
							"src": "160:25:9",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1048,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1046,
											"name": "start",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1039,
											"src": "166:5:9",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 1047,
											"name": "_start",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1043,
											"src": "174:6:9",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "166:14:9",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1049,
									"nodeType": "ExpressionStatement",
									"src": "166:14:9"
								}
							]
						},
						"documentation": null,
						"id": 1051,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "setStart",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1044,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1043,
									"name": "_start",
									"nodeType": "VariableDeclaration",
									"scope": 1051,
									"src": "137:14:9",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1042,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "137:7:9",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "136:16:9"
						},
						"payable": false,
						"returnParameters": {
							"id": 1045,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "160:0:9"
						},
						"scope": 1107,
						"src": "119:66:9",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1062,
							"nodeType": "Block",
							"src": "229:45:9",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1060,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1056,
											"name": "calculatedFibNumber",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1041,
											"src": "235:19:9",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1058,
													"name": "n",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1053,
													"src": "267:1:9",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 1057,
												"name": "fibonacci",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1106,
												"src": "257:9:9",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$_t_uint256_$",
													"typeString": "function (uint256) returns (uint256)"
												}
											},
											"id": 1059,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "257:12:9",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "235:34:9",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1061,
									"nodeType": "ExpressionStatement",
									"src": "235:34:9"
								}
							]
						},
						"documentation": null,
						"id": 1063,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "setFibonacci",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1054,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1053,
									"name": "n",
									"nodeType": "VariableDeclaration",
									"scope": 1063,
									"src": "211:9:9",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1052,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "211:7:9",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "210:11:9"
						},
						"payable": false,
						"returnParameters": {
							"id": 1055,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "229:0:9"
						},
						"scope": 1107,
						"src": "189:85:9",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1105,
							"nodeType": "Block",
							"src": "335:180:9",
							"statements": [
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 1072,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1070,
											"name": "n",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1065,
											"src": "345:1:9",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1071,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "350:1:9",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "345:6:9",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": {
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 1077,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1075,
												"name": "n",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1065,
												"src": "380:1:9",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 1076,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "385:1:9",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"src": "380:6:9",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": {
											"condition": {
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1084,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1082,
													"name": "n",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1065,
													"src": "419:1:9",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 1083,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "424:1:9",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"src": "419:6:9",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"falseBody": {
												"id": 1101,
												"nodeType": "Block",
												"src": "454:57:9",
												"statements": [
													{
														"expression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 1099,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		"id": 1092,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 1090,
																			"name": "n",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1065,
																			"src": "479:1:9",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "-",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "31",
																			"id": 1091,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "483:1:9",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_1_by_1",
																				"typeString": "int_const 1"
																			},
																			"value": "1"
																		},
																		"src": "479:5:9",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	],
																	"id": 1089,
																	"name": "fibonacci",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1106,
																	"src": "469:9:9",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$_t_uint256_$",
																		"typeString": "function (uint256) returns (uint256)"
																	}
																},
																"id": 1093,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "469:16:9",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "+",
															"rightExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		"id": 1097,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 1095,
																			"name": "n",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1065,
																			"src": "498:1:9",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "-",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "33",
																			"id": 1096,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "502:1:9",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_3_by_1",
																				"typeString": "int_const 3"
																			},
																			"value": "3"
																		},
																		"src": "498:5:9",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	],
																	"id": 1094,
																	"name": "fibonacci",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1106,
																	"src": "488:9:9",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$_t_uint256_$",
																		"typeString": "function (uint256) returns (uint256)"
																	}
																},
																"id": 1098,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "488:16:9",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"src": "469:35:9",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"functionReturnParameters": 1069,
														"id": 1100,
														"nodeType": "Return",
														"src": "462:42:9"
													}
												]
											},
											"id": 1102,
											"nodeType": "IfStatement",
											"src": "415:96:9",
											"trueBody": {
												"expression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 1087,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1085,
														"name": "start",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1039,
														"src": "434:5:9",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "+",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "32",
														"id": 1086,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "442:1:9",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_2_by_1",
															"typeString": "int_const 2"
														},
														"value": "2"
													},
													"src": "434:9:9",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"functionReturnParameters": 1069,
												"id": 1088,
												"nodeType": "Return",
												"src": "427:16:9"
											}
										},
										"id": 1103,
										"nodeType": "IfStatement",
										"src": "376:135:9",
										"trueBody": {
											"expression": {
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1080,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1078,
													"name": "start",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1039,
													"src": "395:5:9",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "+",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 1079,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "403:1:9",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"src": "395:9:9",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"functionReturnParameters": 1069,
											"id": 1081,
											"nodeType": "Return",
											"src": "388:16:9"
										}
									},
									"id": 1104,
									"nodeType": "IfStatement",
									"src": "341:170:9",
									"trueBody": {
										"expression": {
											"argumentTypes": null,
											"id": 1073,
											"name": "start",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1039,
											"src": "360:5:9",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"functionReturnParameters": 1069,
										"id": 1074,
										"nodeType": "Return",
										"src": "353:12:9"
									}
								}
							]
						},
						"documentation": null,
						"id": 1106,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "fibonacci",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1066,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1065,
									"name": "n",
									"nodeType": "VariableDeclaration",
									"scope": 1106,
									"src": "297:9:9",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1064,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "297:7:9",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "296:11:9"
						},
						"payable": false,
						"returnParameters": {
							"id": 1069,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1068,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1106,
									"src": "326:7:9",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1067,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "326:7:9",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "325:9:9"
						},
						"scope": 1107,
						"src": "278:237:9",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "internal"
					}
				],
				"scope": 1173,
				"src": "26:491:9"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1172,
				"linearizedBaseContracts": [
					1172
				],
				"name": "FakeFibonacciBank",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 1109,
						"name": "fakeFibonacciLibrary",
						"nodeType": "VariableDeclaration",
						"scope": 1172,
						"src": "550:35:9",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 1108,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "550:7:9",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1111,
						"name": "calculatedFibNumber",
						"nodeType": "VariableDeclaration",
						"scope": 1172,
						"src": "589:34:9",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 1110,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "589:7:9",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1114,
						"name": "start",
						"nodeType": "VariableDeclaration",
						"scope": 1172,
						"src": "627:24:9",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 1112,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "627:7:9",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "33",
							"id": 1113,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "650:1:9",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_3_by_1",
								"typeString": "int_const 3"
							},
							"value": "3"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1116,
						"name": "withdrawalCounter",
						"nodeType": "VariableDeclaration",
						"scope": 1172,
						"src": "655:32:9",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 1115,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "655:7:9",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": true,
						"id": 1123,
						"name": "FIBSIG",
						"nodeType": "VariableDeclaration",
						"scope": 1172,
						"src": "691:62:9",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bytes4",
							"typeString": "bytes4"
						},
						"typeName": {
							"id": 1117,
							"name": "bytes4",
							"nodeType": "ElementaryTypeName",
							"src": "691:6:9",
							"typeDescriptions": {
								"typeIdentifier": "t_bytes4",
								"typeString": "bytes4"
							}
						},
						"value": {
							"argumentTypes": null,
							"arguments": [
								{
									"argumentTypes": null,
									"arguments": [
										{
											"argumentTypes": null,
											"hexValue": "7365744669626f6e616363692875696e7432353629",
											"id": 1120,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "string",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "728:23:9",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_stringliteral_fe75faab7f487631650dccb3f82e15d62b457feab524cb13fa48de017c7c3876",
												"typeString": "literal_string \"setFibonacci(uint256)\""
											},
											"value": "setFibonacci(uint256)"
										}
									],
									"expression": {
										"argumentTypes": [
											{
												"typeIdentifier": "t_stringliteral_fe75faab7f487631650dccb3f82e15d62b457feab524cb13fa48de017c7c3876",
												"typeString": "literal_string \"setFibonacci(uint256)\""
											}
										],
										"id": 1119,
										"name": "sha3",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2947,
										"src": "723:4:9",
										"typeDescriptions": {
											"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
											"typeString": "function () pure returns (bytes32)"
										}
									},
									"id": 1121,
									"isConstant": false,
									"isLValue": false,
									"isPure": true,
									"kind": "functionCall",
									"lValueRequested": false,
									"names": [],
									"nodeType": "FunctionCall",
									"src": "723:29:9",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									}
								}
							],
							"expression": {
								"argumentTypes": [
									{
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									}
								],
								"id": 1118,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"lValueRequested": false,
								"nodeType": "ElementaryTypeNameExpression",
								"src": "716:6:9",
								"typeDescriptions": {
									"typeIdentifier": "t_type$_t_bytes4_$",
									"typeString": "type(bytes4)"
								},
								"typeName": "bytes4"
							},
							"id": 1122,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "typeConversion",
							"lValueRequested": false,
							"names": [],
							"nodeType": "FunctionCall",
							"src": "716:37:9",
							"typeDescriptions": {
								"typeIdentifier": "t_bytes4",
								"typeString": "bytes4"
							}
						},
						"visibility": "internal"
					},
					{
						"body": {
							"id": 1132,
							"nodeType": "Block",
							"src": "816:55:9",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1130,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1128,
											"name": "fakeFibonacciLibrary",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1109,
											"src": "822:20:9",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 1129,
											"name": "_fakeFibonacciLibrary",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1125,
											"src": "845:21:9",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "822:44:9",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1131,
									"nodeType": "ExpressionStatement",
									"src": "822:44:9"
								}
							]
						},
						"documentation": null,
						"id": 1133,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1126,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1125,
									"name": "_fakeFibonacciLibrary",
									"nodeType": "VariableDeclaration",
									"scope": 1133,
									"src": "770:29:9",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1124,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "770:7:9",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "769:31:9"
						},
						"payable": true,
						"returnParameters": {
							"id": 1127,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "816:0:9"
						},
						"scope": 1172,
						"src": "758:113:9",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1158,
							"nodeType": "Block",
							"src": "895:238:9",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1138,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1136,
											"name": "withdrawalCounter",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1116,
											"src": "901:17:9",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "+=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "31",
											"id": 1137,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "922:1:9",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_1_by_1",
												"typeString": "int_const 1"
											},
											"value": "1"
										},
										"src": "901:22:9",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1139,
									"nodeType": "ExpressionStatement",
									"src": "901:22:9"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 1143,
														"name": "FIBSIG",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1123,
														"src": "1041:6:9",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes4",
															"typeString": "bytes4"
														}
													},
													{
														"argumentTypes": null,
														"id": 1144,
														"name": "withdrawalCounter",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1116,
														"src": "1049:17:9",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_bytes4",
															"typeString": "bytes4"
														},
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													],
													"expression": {
														"argumentTypes": null,
														"id": 1141,
														"name": "fakeFibonacciLibrary",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1109,
														"src": "1007:20:9",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"id": 1142,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "delegatecall",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "1007:33:9",
													"typeDescriptions": {
														"typeIdentifier": "t_function_baredelegatecall_nonpayable$__$returns$_t_bool_$",
														"typeString": "function () returns (bool)"
													}
												},
												"id": 1145,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "1007:60:9",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1140,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "999:7:9",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1146,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "999:69:9",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1147,
									"nodeType": "ExpressionStatement",
									"src": "999:69:9"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1155,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1153,
													"name": "calculatedFibNumber",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1111,
													"src": "1094:19:9",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "*",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "302e303031",
													"id": 1154,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1116:11:9",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000_by_1",
														"typeString": "int_const 1000000000000000"
													},
													"value": "0.001"
												},
												"src": "1094:33:9",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1148,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "1074:3:9",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1151,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "1074:10:9",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 1152,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "1074:19:9",
											"typeDescriptions": {
												"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 1156,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1074:54:9",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1157,
									"nodeType": "ExpressionStatement",
									"src": "1074:54:9"
								}
							]
						},
						"documentation": null,
						"id": 1159,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "withdraw",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1134,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "892:2:9"
						},
						"payable": false,
						"returnParameters": {
							"id": 1135,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "895:0:9"
						},
						"scope": 1172,
						"src": "875:258:9",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1170,
							"nodeType": "Block",
							"src": "1155:63:9",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1165,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2937,
															"src": "1203:3:9",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 1166,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "data",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "1203:8:9",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes_calldata_ptr",
															"typeString": "bytes calldata"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_bytes_calldata_ptr",
															"typeString": "bytes calldata"
														}
													],
													"expression": {
														"argumentTypes": null,
														"id": 1163,
														"name": "fakeFibonacciLibrary",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1109,
														"src": "1169:20:9",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"id": 1164,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "delegatecall",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "1169:33:9",
													"typeDescriptions": {
														"typeIdentifier": "t_function_baredelegatecall_nonpayable$__$returns$_t_bool_$",
														"typeString": "function () returns (bool)"
													}
												},
												"id": 1167,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "1169:43:9",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1162,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "1161:7:9",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1168,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1161:52:9",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1169,
									"nodeType": "ExpressionStatement",
									"src": "1161:52:9"
								}
							]
						},
						"documentation": null,
						"id": 1171,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1160,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1145:2:9"
						},
						"payable": false,
						"returnParameters": {
							"id": 1161,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1155:0:9"
						},
						"scope": 1172,
						"src": "1137:81:9",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 1173,
				"src": "519:701:9"
			}
		],
		"src": "0:1221:9"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/FakeFibonacciBank.sol",
		"exportedSymbols": {
			"FakeFibonacciBank": [
				1172
			],
			"FakeFibonacciLib": [
				1107
			]
		},
		"id": 1173,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1037,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:9"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1107,
				"linearizedBaseContracts": [
					1107
				],
				"name": "FakeFibonacciLib",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 1039,
						"name": "start",
						"nodeType": "VariableDeclaration",
						"scope": 1107,
						"src": "56:20:9",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 1038,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "56:7:9",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1041,
						"name": "calculatedFibNumber",
						"nodeType": "VariableDeclaration",
						"scope": 1107,
						"src": "80:34:9",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 1040,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "80:7:9",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1050,
							"nodeType": "Block",
							"src": "160:25:9",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1048,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1046,
											"name": "start",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1039,
											"src": "166:5:9",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 1047,
											"name": "_start",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1043,
											"src": "174:6:9",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "166:14:9",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1049,
									"nodeType": "ExpressionStatement",
									"src": "166:14:9"
								}
							]
						},
						"documentation": null,
						"id": 1051,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "setStart",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1044,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1043,
									"name": "_start",
									"nodeType": "VariableDeclaration",
									"scope": 1051,
									"src": "137:14:9",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1042,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "137:7:9",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "136:16:9"
						},
						"payable": false,
						"returnParameters": {
							"id": 1045,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "160:0:9"
						},
						"scope": 1107,
						"src": "119:66:9",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1062,
							"nodeType": "Block",
							"src": "229:45:9",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1060,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1056,
											"name": "calculatedFibNumber",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1041,
											"src": "235:19:9",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1058,
													"name": "n",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1053,
													"src": "267:1:9",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 1057,
												"name": "fibonacci",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1106,
												"src": "257:9:9",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$_t_uint256_$",
													"typeString": "function (uint256) returns (uint256)"
												}
											},
											"id": 1059,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "257:12:9",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "235:34:9",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1061,
									"nodeType": "ExpressionStatement",
									"src": "235:34:9"
								}
							]
						},
						"documentation": null,
						"id": 1063,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "setFibonacci",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1054,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1053,
									"name": "n",
									"nodeType": "VariableDeclaration",
									"scope": 1063,
									"src": "211:9:9",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1052,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "211:7:9",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "210:11:9"
						},
						"payable": false,
						"returnParameters": {
							"id": 1055,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "229:0:9"
						},
						"scope": 1107,
						"src": "189:85:9",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1105,
							"nodeType": "Block",
							"src": "335:180:9",
							"statements": [
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 1072,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 1070,
											"name": "n",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1065,
											"src": "345:1:9",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1071,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "350:1:9",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "345:6:9",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": {
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 1077,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1075,
												"name": "n",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1065,
												"src": "380:1:9",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 1076,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "385:1:9",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"src": "380:6:9",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": {
											"condition": {
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1084,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1082,
													"name": "n",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1065,
													"src": "419:1:9",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 1083,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "424:1:9",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"src": "419:6:9",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"falseBody": {
												"id": 1101,
												"nodeType": "Block",
												"src": "454:57:9",
												"statements": [
													{
														"expression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 1099,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		"id": 1092,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 1090,
																			"name": "n",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1065,
																			"src": "479:1:9",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "-",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "31",
																			"id": 1091,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "483:1:9",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_1_by_1",
																				"typeString": "int_const 1"
																			},
																			"value": "1"
																		},
																		"src": "479:5:9",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	],
																	"id": 1089,
																	"name": "fibonacci",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1106,
																	"src": "469:9:9",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$_t_uint256_$",
																		"typeString": "function (uint256) returns (uint256)"
																	}
																},
																"id": 1093,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "469:16:9",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "+",
															"rightExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		"id": 1097,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 1095,
																			"name": "n",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1065,
																			"src": "498:1:9",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "-",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "33",
																			"id": 1096,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "502:1:9",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_3_by_1",
																				"typeString": "int_const 3"
																			},
																			"value": "3"
																		},
																		"src": "498:5:9",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	],
																	"id": 1094,
																	"name": "fibonacci",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1106,
																	"src": "488:9:9",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$_t_uint256_$",
																		"typeString": "function (uint256) returns (uint256)"
																	}
																},
																"id": 1098,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "488:16:9",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"src": "469:35:9",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"functionReturnParameters": 1069,
														"id": 1100,
														"nodeType": "Return",
														"src": "462:42:9"
													}
												]
											},
											"id": 1102,
											"nodeType": "IfStatement",
											"src": "415:96:9",
											"trueBody": {
												"expression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 1087,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1085,
														"name": "start",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1039,
														"src": "434:5:9",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "+",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "32",
														"id": 1086,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "442:1:9",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_2_by_1",
															"typeString": "int_const 2"
														},
														"value": "2"
													},
													"src": "434:9:9",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"functionReturnParameters": 1069,
												"id": 1088,
												"nodeType": "Return",
												"src": "427:16:9"
											}
										},
										"id": 1103,
										"nodeType": "IfStatement",
										"src": "376:135:9",
										"trueBody": {
											"expression": {
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1080,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1078,
													"name": "start",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1039,
													"src": "395:5:9",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "+",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 1079,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "403:1:9",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"src": "395:9:9",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"functionReturnParameters": 1069,
											"id": 1081,
											"nodeType": "Return",
											"src": "388:16:9"
										}
									},
									"id": 1104,
									"nodeType": "IfStatement",
									"src": "341:170:9",
									"trueBody": {
										"expression": {
											"argumentTypes": null,
											"id": 1073,
											"name": "start",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1039,
											"src": "360:5:9",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"functionReturnParameters": 1069,
										"id": 1074,
										"nodeType": "Return",
										"src": "353:12:9"
									}
								}
							]
						},
						"documentation": null,
						"id": 1106,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "fibonacci",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1066,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1065,
									"name": "n",
									"nodeType": "VariableDeclaration",
									"scope": 1106,
									"src": "297:9:9",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1064,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "297:7:9",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "296:11:9"
						},
						"payable": false,
						"returnParameters": {
							"id": 1069,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1068,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1106,
									"src": "326:7:9",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1067,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "326:7:9",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "325:9:9"
						},
						"scope": 1107,
						"src": "278:237:9",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "internal"
					}
				],
				"scope": 1173,
				"src": "26:491:9"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1172,
				"linearizedBaseContracts": [
					1172
				],
				"name": "FakeFibonacciBank",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 1109,
						"name": "fakeFibonacciLibrary",
						"nodeType": "VariableDeclaration",
						"scope": 1172,
						"src": "550:35:9",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 1108,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "550:7:9",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1111,
						"name": "calculatedFibNumber",
						"nodeType": "VariableDeclaration",
						"scope": 1172,
						"src": "589:34:9",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 1110,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "589:7:9",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1114,
						"name": "start",
						"nodeType": "VariableDeclaration",
						"scope": 1172,
						"src": "627:24:9",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 1112,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "627:7:9",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "33",
							"id": 1113,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "650:1:9",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_3_by_1",
								"typeString": "int_const 3"
							},
							"value": "3"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 1116,
						"name": "withdrawalCounter",
						"nodeType": "VariableDeclaration",
						"scope": 1172,
						"src": "655:32:9",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 1115,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "655:7:9",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": true,
						"id": 1123,
						"name": "FIBSIG",
						"nodeType": "VariableDeclaration",
						"scope": 1172,
						"src": "691:62:9",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bytes4",
							"typeString": "bytes4"
						},
						"typeName": {
							"id": 1117,
							"name": "bytes4",
							"nodeType": "ElementaryTypeName",
							"src": "691:6:9",
							"typeDescriptions": {
								"typeIdentifier": "t_bytes4",
								"typeString": "bytes4"
							}
						},
						"value": {
							"argumentTypes": null,
							"arguments": [
								{
									"argumentTypes": null,
									"arguments": [
										{
											"argumentTypes": null,
											"hexValue": "7365744669626f6e616363692875696e7432353629",
											"id": 1120,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "string",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "728:23:9",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_stringliteral_fe75faab7f487631650dccb3f82e15d62b457feab524cb13fa48de017c7c3876",
												"typeString": "literal_string \"setFibonacci(uint256)\""
											},
											"value": "setFibonacci(uint256)"
										}
									],
									"expression": {
										"argumentTypes": [
											{
												"typeIdentifier": "t_stringliteral_fe75faab7f487631650dccb3f82e15d62b457feab524cb13fa48de017c7c3876",
												"typeString": "literal_string \"setFibonacci(uint256)\""
											}
										],
										"id": 1119,
										"name": "sha3",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2947,
										"src": "723:4:9",
										"typeDescriptions": {
											"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
											"typeString": "function () pure returns (bytes32)"
										}
									},
									"id": 1121,
									"isConstant": false,
									"isLValue": false,
									"isPure": true,
									"kind": "functionCall",
									"lValueRequested": false,
									"names": [],
									"nodeType": "FunctionCall",
									"src": "723:29:9",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									}
								}
							],
							"expression": {
								"argumentTypes": [
									{
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									}
								],
								"id": 1118,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"lValueRequested": false,
								"nodeType": "ElementaryTypeNameExpression",
								"src": "716:6:9",
								"typeDescriptions": {
									"typeIdentifier": "t_type$_t_bytes4_$",
									"typeString": "type(bytes4)"
								},
								"typeName": "bytes4"
							},
							"id": 1122,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "typeConversion",
							"lValueRequested": false,
							"names": [],
							"nodeType": "FunctionCall",
							"src": "716:37:9",
							"typeDescriptions": {
								"typeIdentifier": "t_bytes4",
								"typeString": "bytes4"
							}
						},
						"visibility": "internal"
					},
					{
						"body": {
							"id": 1132,
							"nodeType": "Block",
							"src": "816:55:9",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1130,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1128,
											"name": "fakeFibonacciLibrary",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1109,
											"src": "822:20:9",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 1129,
											"name": "_fakeFibonacciLibrary",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1125,
											"src": "845:21:9",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "822:44:9",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1131,
									"nodeType": "ExpressionStatement",
									"src": "822:44:9"
								}
							]
						},
						"documentation": null,
						"id": 1133,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1126,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1125,
									"name": "_fakeFibonacciLibrary",
									"nodeType": "VariableDeclaration",
									"scope": 1133,
									"src": "770:29:9",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1124,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "770:7:9",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "769:31:9"
						},
						"payable": true,
						"returnParameters": {
							"id": 1127,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "816:0:9"
						},
						"scope": 1172,
						"src": "758:113:9",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1158,
							"nodeType": "Block",
							"src": "895:238:9",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1138,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1136,
											"name": "withdrawalCounter",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1116,
											"src": "901:17:9",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "+=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "31",
											"id": 1137,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "922:1:9",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_1_by_1",
												"typeString": "int_const 1"
											},
											"value": "1"
										},
										"src": "901:22:9",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1139,
									"nodeType": "ExpressionStatement",
									"src": "901:22:9"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 1143,
														"name": "FIBSIG",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1123,
														"src": "1041:6:9",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes4",
															"typeString": "bytes4"
														}
													},
													{
														"argumentTypes": null,
														"id": 1144,
														"name": "withdrawalCounter",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1116,
														"src": "1049:17:9",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_bytes4",
															"typeString": "bytes4"
														},
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													],
													"expression": {
														"argumentTypes": null,
														"id": 1141,
														"name": "fakeFibonacciLibrary",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1109,
														"src": "1007:20:9",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"id": 1142,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "delegatecall",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "1007:33:9",
													"typeDescriptions": {
														"typeIdentifier": "t_function_baredelegatecall_nonpayable$__$returns$_t_bool_$",
														"typeString": "function () returns (bool)"
													}
												},
												"id": 1145,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "1007:60:9",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1140,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "999:7:9",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1146,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "999:69:9",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1147,
									"nodeType": "ExpressionStatement",
									"src": "999:69:9"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1155,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1153,
													"name": "calculatedFibNumber",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1111,
													"src": "1094:19:9",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "*",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "302e303031",
													"id": 1154,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1116:11:9",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000_by_1",
														"typeString": "int_const 1000000000000000"
													},
													"value": "0.001"
												},
												"src": "1094:33:9",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1148,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "1074:3:9",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1151,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "1074:10:9",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 1152,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "1074:19:9",
											"typeDescriptions": {
												"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 1156,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1074:54:9",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1157,
									"nodeType": "ExpressionStatement",
									"src": "1074:54:9"
								}
							]
						},
						"documentation": null,
						"id": 1159,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "withdraw",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1134,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "892:2:9"
						},
						"payable": false,
						"returnParameters": {
							"id": 1135,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "895:0:9"
						},
						"scope": 1172,
						"src": "875:258:9",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1170,
							"nodeType": "Block",
							"src": "1155:63:9",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1165,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2937,
															"src": "1203:3:9",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 1166,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "data",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "1203:8:9",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes_calldata_ptr",
															"typeString": "bytes calldata"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_bytes_calldata_ptr",
															"typeString": "bytes calldata"
														}
													],
													"expression": {
														"argumentTypes": null,
														"id": 1163,
														"name": "fakeFibonacciLibrary",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1109,
														"src": "1169:20:9",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"id": 1164,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "delegatecall",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "1169:33:9",
													"typeDescriptions": {
														"typeIdentifier": "t_function_baredelegatecall_nonpayable$__$returns$_t_bool_$",
														"typeString": "function () returns (bool)"
													}
												},
												"id": 1167,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "1169:43:9",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1162,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "1161:7:9",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1168,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1161:52:9",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1169,
									"nodeType": "ExpressionStatement",
									"src": "1161:52:9"
								}
							]
						},
						"documentation": null,
						"id": 1171,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1160,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1145:2:9"
						},
						"payable": false,
						"returnParameters": {
							"id": 1161,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1155:0:9"
						},
						"scope": 1172,
						"src": "1137:81:9",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 1173,
				"src": "519:701:9"
			}
		],
		"src": "0:1221:9"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.800Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/FakeFibonacciLib.json
// module id = 1036
// module chunks = 0